import { Eyebrow } from './Eyebrow'
import { SplitHeading } from '../animation/SplitHeading'
import { LeafMark } from './Logo'
import { AccentGlow } from './AccentGlow'
import { cn } from '../../lib/cn'

interface PageHeaderProps {
  eyebrow?: string
  title: string
  subtitle?: string
  accent?: string
  children?: React.ReactNode
  className?: string
  align?: 'left' | 'center'
}

/** Consistent dark page-opening band (keeps the transparent navbar legible on every route). */
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  accent = '#159A3C',
  children,
  className,
  align = 'left',
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        'grain relative overflow-hidden bg-night pb-14 pt-[calc(var(--nav-h)+3.5rem)] text-white md:pb-20',
        className,
      )}
      style={{ ['--leaf-vein' as string]: '#06231A' }}
    >
      <AccentGlow color={accent} intensity={0.5} className="right-[-10%] top-[-20%] h-[36rem] w-[36rem]" />
      <AccentGlow color="#159A3C" intensity={0.28} className="left-[-8%] bottom-[-30%] h-[30rem] w-[30rem]" />
      <LeafMark className="pointer-events-none absolute -right-10 bottom-0 h-72 w-72 rotate-12 text-white/[0.04]" />

      <div className={cn('container-x relative', align === 'center' && 'text-center')}>
        {eyebrow && (
          <div className={cn(align === 'center' && 'flex justify-center')}>
            <Eyebrow tone="light" className="mb-4" style={{ color: accent }}>
              {eyebrow}
            </Eyebrow>
          </div>
        )}
        <SplitHeading
          as="h1"
          text={title}
          type="lines"
          start="top 95%"
          className={cn('max-w-4xl font-display text-display-xl font-semibold text-white', align === 'center' && 'mx-auto')}
        />
        {subtitle && (
          <p className={cn('mt-5 max-w-2xl text-lead text-white/70', align === 'center' && 'mx-auto')}>{subtitle}</p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </header>
  )
}
